export default __webpack_public_path__ + "media/images/triangle-500a8d2a53a570765bb336589cb96de1.png";